import { createSlice } from "@reduxjs/toolkit";
import PostGIFProps from "./postGIF";

const initialState: PostGIFProps.State = {
  postGIF: {} as PostGIFProps.PostGIF,
};

const slice = createSlice({
  name: "postGIF",
  initialState,
  reducers: {
    setPostGIF: (state, action: PostGIFProps.setPostGIF) => {
      state.postGIF = action.payload;
    },
    reset: () => initialState,
  },
});

export const postGIFActions = slice.actions;
export const postGIFReducer = slice.reducer;
